/** Frontmatter for the "preseason-week-1-recap" article; the Body lives in preseason-week-1-recap.jsx. */
const meta = {
  slug: 'preseason-week-1-recap',
  title: 'NFL Preseason Week 1 Recap: Stock Watch, Standouts, and Casualties',
  category: 'Recap',
  author: 'AndyDarkness',
  excerpt:
    'All 16 preseason openers broken down with corrected scores, fantasy risers and duds, standout performances, and every injury that matters for your draft board.',
  readMinutes: 12,
  date: '2026-08-18',
};

export default meta;
